import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

interface IProps {
  show: boolean;
  message: string;
  children: React.ReactNode;
}

export const CustomTooltip = ({ show, message, children }: IProps) => {
  if (!show) return <div>{children}</div>;
  return (
    <Tooltip title={message} placement='top'>
      <div>{children}</div>
    </Tooltip>
  );
};
